'use strict';

angular.module('cdPay.components', [
  'cdPay.components.inputHelper',
  'cdPay.components.projectCheckout',
  'cdPay.components.projectStatus',
  'cdPay.components.projectThanks',
]);
